import React from "react";
import style from './Welcome.module.scss';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import RadioGroup from "@mui/material/RadioGroup";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import FormLayout from "../../../components/FormLayout";
import ThumbsIconRadioButton from "./ThumbsIconRadioButton";
import { connect, useSelector } from "react-redux";
import { userSetupSlice } from "../../../store/reducer/user_setup";
import CustomButton from "../../../components/CustomButton";
import InfoCircleIcon from "@mui/icons-material/InfoRounded";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AccessibleFormControlLabel from "./AccessibleFormControlLabel";
import { Alert } from "@mui/material";

const Welcome = ({
  dispatch,
  user: { address_1, address_2, city, state, zip, is_resident_for_the_entire_year },
  userSetupState: { infoAccurate },
}: any) => {
  const currentTaxYear = useSelector((state: any) => state.state.taxYear);

  return (
    // This should be considered the default splash page for a user needing to file.
    // All new users have already verified their address during sign in,
    // this page is to verify whether they lived there all year
    // If yes, move on to personal info screen,
    // if no, then Sorry
    <FormLayout
      title={"Let's get started"}
      subtitle={"welcome"}
    >
      <Alert
        severity="info"
        variant="outlined"
        classes={{
          root: "info-alert",
          icon: "info-icon",
        }}
        sx={{ fontSize: "18px", fontWeight: "bold" }}
        iconMapping={{ info: <InfoCircleIcon /> }}
      >Note: LIME may only be used to file taxes for the current tax year ({currentTaxYear}).</Alert>
      <br></br>

      { is_resident_for_the_entire_year === false &&
      <>
        <Alert
          severity="error"
          variant="outlined"
          classes={{
            root: "error-alert",
            icon: "info-icon",
          }}
          sx={{ fontSize: "16px"}}
          iconMapping={{ info: <ErrorOutlineIcon /> }}
        >
          The address you entered for your other address did not appear to be located in the City of Springboro.
          In order to use LIME, you must have lived in Springboro for the entire tax year.
        </Alert>
        <br/>
      </>
      }
      <Grid
        container
        direction="column"
        alignItems="flex-start"
        justifyContent="space-evenly"
        spacing={3}>
        <Grid size="grow">
          <p className='context'>The address we have on file for you is:</p>
          <Box className={style.addressBlock}>
            <p className={style.addressLine}>
              {(address_2) ? address_1 + ', ' + address_2 : address_1}
            </p>
            <p className={style.addressLine}>
              {city}, {state} {zip}
            </p>
          </Box>
        </Grid>
        <Grid size={12}>
          <span className='prompt'>
            {`Did you live at this address for all of ${currentTaxYear}?`}
          </span>
          <RadioGroup
            value={infoAccurate}
            className={style.radioGroup}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              // eslint-disable-next-line
              dispatch(userSetupSlice.actions.setInfoAccurate(e.target.value == "true"))
            }
          >
            <AccessibleFormControlLabel
              value={true}
              control={
                <ThumbsIconRadioButton
                  checkedIcon={<ThumbUpIcon className={`${style.icon} ${style.checked}`} />}
                  icon={<ThumbUpIcon className={style.icon} />}
                  disabled={is_resident_for_the_entire_year === false}
                />
              }
              label={
                <p className={style.btnLabel}>
                  <span className={style.btnLabelBold}>YES</span>
                  <br />
                  This information is accurate.
                </p>
              }
              className={
                `${style.radioBlock} ${infoAccurate ? style.checked : ''}`
              }
            />
            <AccessibleFormControlLabel
              value={false}
              control={
                <ThumbsIconRadioButton
                  checkedIcon={<ThumbDownIcon className={`${style.icon} ${style.checked}`} />}
                  icon={<ThumbDownIcon className={style.icon} />}
                />
              }
              label={
                <p className={style.btnLabel}>
                  <span className={style.btnLabelBold}>NO</span>
                  <br />I moved in {currentTaxYear}.
                </p>
              }
              className={
                `${style.radioBlock} ${infoAccurate ? '' : style.checked}`
              }
            />
          </RadioGroup>
        </Grid>
      </Grid>
      <div className='btn-container single'>
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          type="submit"
          onClick={() => {
            dispatch(userSetupSlice.actions.confirmStep());
          }}
          buttonSize="btn-lg"
        />
      </div>
    </FormLayout>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    userSetupState: state.userSetup
  };
};

export default connect(mapStateToProps)(Welcome);
